import type { CategoryColor } from "../../utils/eventDisplay";

const TAG_STYLES: Record<CategoryColor, string> = {
    pink: "bg-accent-pink/40 text-foreground",
    green: "bg-accent-green/50 text-foreground",
    orange: "bg-accent-peach/50 text-foreground",
    purple: "bg-accent-purple/40 text-foreground",
    blue: "bg-accent-blue/40 text-foreground",
};

const DOT_STYLES: Record<CategoryColor, string> = {
    pink: "bg-[#e879a8]",
    green: "bg-[#4ade80]",
    orange: "bg-[#f97316]",
    purple: "bg-[#a78bfa]",
    blue: "bg-[#60a5fa]",
};

type Props = {
    label: string;
    color?: CategoryColor;
    variant?: "category" | "free";
};

export function EventTag({ label, color = "green", variant = "category" }: Props) {
    if (variant === "free") {
        return (
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-green/50 px-2.5 py-0.5 text-xs font-medium text-foreground">
                <span className="size-1.5 rounded-full bg-[#4ade80]" />
                {label}
            </span>
        );
    }

    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${TAG_STYLES[color]}`}
        >
            <span className={`size-1.5 rounded-full ${DOT_STYLES[color]}`} />
            {label}
        </span>
    );
}
